<div class="text-center" [innerHTML]="svgTemplate"></div>